import { usePageTitleTranslation } from 'libs/navigation';

import { useFormFM1Form } from '../hooks/useFormFM1Form';
import { FormFM1View } from '../views';

export const FormFM1Container = () => {
  const {
    isSuccessGenerate,
    errorMessage,
    isError,
    submitLoading,
    initialValues,
    setIsError,
    onSubmit,
    onDownloadFile,
    onBack,
  } = useFormFM1Form();

  usePageTitleTranslation('formFM1.title');

  return (
    <FormFM1View
      errorMessage={errorMessage}
      initialValues={initialValues}
      isError={isError}
      isSuccessGenerate={isSuccessGenerate}
      setIsError={setIsError}
      submitLoading={submitLoading}
      onBack={onBack}
      onDownloadFile={onDownloadFile}
      onSubmit={onSubmit}
    />
  );
};
